(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/assets/javascripts/route-components/route-ranking.js') >= 0) return;  svs.modules.push('/modules/poker-react/assets/javascripts/route-components/route-ranking.js');
"use strict";


const WidgetArea = svs.components.lbUtils.widgetArea.WidgetArea;
const _svs$poker_react$comp = svs.poker_react.components,
  PoyScoreCalculator = _svs$poker_react$comp.PoyScoreCalculator,
  PoyWinners = _svs$poker_react$comp.PoyWinners,
  PoyRankingList = _svs$poker_react$comp.poyRankingList.PoyRankingList;
const StaticWidgetArea = svs.poker_react.components.common.constants.StaticWidgetArea;
const RouteRanking = () => {
  var _svs$poker_react$data, _svs$poker_react$data2;
  const rankingListVisible = (_svs$poker_react$data = svs.poker_react.data.poyCurrentRankingConfig) === null || _svs$poker_react$data === void 0 ? void 0 : _svs$poker_react$data.visible;
  const winnerListVisible = (_svs$poker_react$data2 = svs.poker_react.data.poyWinConfig) === null || _svs$poker_react$data2 === void 0 ? void 0 : _svs$poker_react$data2.listVisible;
  return React.createElement("section", {
    className: "poker-react-content"
  }, rankingListVisible && React.createElement(PoyRankingList, null), winnerListVisible && React.createElement(PoyWinners, null), React.createElement("section", null, React.createElement(WidgetArea, {
    widgetArea: StaticWidgetArea.Ranking
  })), React.createElement(PoyScoreCalculator, null));
};
setGlobal('svs.poker_react.routeComponents.RouteRanking', RouteRanking);

 })(window);